/** Значение, не содержащее цифры */
export const nonNumbersRegExp = /\D/g;
